import { useEffect, useState } from 'react';

const useInjector = () => {
  const [injector, setInjector] = useState(() =>
    window.angular.element(document.body).injector(),
  );

  useEffect(() => {
    if (!injector) {
      window.APP_EXTENSION_SDK_ANGULAR_JS_LOADED.then(() => {
        setInjector(window.angular.element(document.body).injector());
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return injector;
};

export default useInjector;
